import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DatePicker } from "@mui/x-date-pickers";
import { useToastContext } from "components/alert/ToastContext";
import { Label } from "components/input/Label";
import dayjs from "dayjs";
import saveAs from 'file-saver';
import Produto from "model/administracao/cadastro/produto/Produto";
import MetaPorUsuarioRelatorioFilters from "model/meta/producao/MetaPorUsuarioRelatorioFilters";
import PrevisaoConsumoMateriaPrimaFilter from "model/suprimentos/reports/PrevisaoConsumoMateriaPrimaFilter";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import OrdemProducaoService from "service/producao/OrdemProducaoService";
import EstoqueService from "service/suprimentos/EstoqueService";

type Props = {
    visible: boolean;
    onHide: () => void;
}

const estoqueService = new EstoqueService();
export default function ModalGerarRelatorioPrevisaoMateriaPrima(props: Props) {

    const { msgErro, msgAlerta } = useToastContext();
    const { startLoading, stopLoading } = useLoadingContext();
    const [filters, setFilters] = useState<PrevisaoConsumoMateriaPrimaFilter[]>([]);

    const [produtos, setProdutos] = useState<Produto[]>([]);

    useEffect(() => {
        estoqueService.getProdutosProduzidos().then((response) => {
            setProdutos(response);
        }).catch((err) => {
            console.error(err);
        });
    }, [])

    const handleConfirm = () => {
        if (!validar()) {
            return;
        }
        gerarRelatorio();
    }

    const validar = () => {
        if (filters.length === 0) {
            msgAlerta("Alerta", "É necessário informar ao menos um produto produzido.");
            return false;
        }
        for (let i = 0; i < filters.length; i++) {
            const filter = filters[i];
            if (!filter.produto) {
                msgAlerta("Alerta", `É necessário informar o produto produzido para a linha ${i + 1}.`);
                return false;
            }
            if (filter.quantidadeProduzir <= 0) {
                msgAlerta("Alerta", `A quantidade a produzir deve ser maior que zero para a linha ${i + 1}.`);
                return false;
            }
        }
        return true;
    }

    const gerarRelatorio = () => {
        startLoading();
        estoqueService.getRelatorioPrevisaoMateriaPrima(filters).then((data) => {
            stopLoading();
            const file = new Blob([data], { type: 'application/pdf' });
            saveAs(file, `Previsão de MP.pdf`);
        }).catch((err) => {
            msgErro("Erro", err?.data?.message || "Ocorreu um erro ao gerar relatório de previsão de consumo de matéria-prima.");
            stopLoading();
            console.error(err);
        });
    }

    const tableHeader = (
        <div style={{ display: "flex", justifyContent: "space-between", textAlign: 'center', alignContent: "center" }}>
            <div></div>
            <span style={{ textAlign: 'center', alignSelf: "center", position: 'relative' }}>Produtos Produzidos</span>
            <Button
                style={{}}
                type="button" icon={<FontAwesomeIcon icon="add" />}
                className="ui-button-info"
                onClick={() => setFilters([...filters, { produto: null, quantidadeProduzir: 0 }])}
            ></Button>
        </div>
    )


    return (
        <Dialog
            header="Gerar relatório de previsão de consumo de matéria-prima"
            visible={props.visible}
            baseZIndex={100}
            style={{ width: '700px' }}
            onHide={props.onHide}
            footer={<>
                <Button label="Fechar" icon="pi pi-times" className="p-button-danger" onClick={props.onHide} />
                <Button label="Gerar" icon="pi pi-check" onClick={() => handleConfirm()} />
            </>}
        >
            <DataTable
                header={tableHeader}
                value={filters}
            >
                <Column header="Produto produzido" field="produto.nome" body={(rowData: PrevisaoConsumoMateriaPrimaFilter, options) => {
                    return <Dropdown
                        style={{ width: "100%" }}
                        filter
                        filterBy="codigo,nome"
                        value={rowData.produto}
                        options={produtos}
                        optionLabel="nome"
                        itemTemplate={(option: Produto) => <div>{option.codigo + " - " + option.nome}</div>}
                        onChange={(e) => {
                            const updatedFilters = [...filters];
                            updatedFilters[options.rowIndex] = { ...rowData, produto: e.value };
                            setFilters(updatedFilters);
                        }}
                    />
                }} />
                <Column header="Quantidade a produzir" field="quantidadeProduzir" style={{ width: 200 }} body={(rowData: PrevisaoConsumoMateriaPrimaFilter, options) => {
                    return <InputNumber
                        locale="pt-BR"
                        maxFractionDigits={2}
                        value={rowData.quantidadeProduzir}
                        onValueChange={(e) => {
                            const updatedFilters = [...filters];
                            updatedFilters[options.rowIndex] = { ...rowData, quantidadeProduzir: e.value || 0 };
                            setFilters(updatedFilters);
                        }} />
                }} />

            </DataTable>
        </Dialog>
    )
}